import { itemName } from '../../trace/ports.js';
import { traceForward } from '../../trace/trace.js';
import { defineRule } from '../rule.js';
import { isListHolder } from '../../materials/list.js';

/** H: a microphone whose signal reaches no channel (neither directly nor through the patch). */
export const micWithoutChannel = defineRule(
  'mic-without-channel',
  'hint',
  { en: 'Microphone without channel', de: 'Mikrofon ohne Kanal' },
  (data, emit) =>
    Object.values(data.items)
      // pure list boxes are no mics; a channel naming the mic as its source is enough
      .filter((item) => item.kind === 'microphone' && !isListHolder(item))
      .filter((item) => !Object.values(data.channels).some((c) => c.sourceItemId === item.id))
      .filter(
        (item) => !traceForward(data, { itemId: item.id }).some((h) => h.to.type === 'channel'),
      )
      .map((item) => emit([item.id], { label: itemName(item) })),
);
